module.exports = __webpack_public_path__ + "static/ActiveCollab-fe35d754ad05d395fab4a43edf0a6fab.svg";